function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Utility from "../commons/Utility";
import * as Api from "../ajax/SessionApi"; /// <reference path="types/MicrosoftMaps/Microsoft.Maps.All.d.ts" />

import IntlMessage from '../commons/Intl';
import { Label, Placeholder, Action, Terrain, Errors } from '../commons/IntlMessages';
import { ApiResultCodes } from "../enum/ApiResultCodes";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // 地形生成 モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 表示中
   */

  Mode[Mode["Show"] = 1] = "Show";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      Modal: null,
      MaterialFileName: null,
      LatitudeValue: props.defaultSelectLatitude == null ? 0 : props.defaultSelectLatitude,
      LongitudeValue: props.defaultSelectLongitude == null ? 0 : props.defaultSelectLongitude,
      LevelValue: props.defaultSelectLevel == null ? 0 : props.defaultSelectLevel,
      Keyword: "",
      ErrorMessages: [],
      Map: null,
      KeywordDangerText: null,
      SearchManager: null
    };
    return _this;
  }
  /**
   * 「検索」ボタン押下時の処理を行います。
   */


  _createClass(MainComponent, [{
    key: "onSearch",
    value: function onSearch() {
      var _this2 = this;

      if (this.state.SearchManager == null) {
        throw Error();
      }

      Api.Check(function (data) {
        if (data.ResultCode != ApiResultCodes.Success) {
          return;
        }

        if (_this2.state.SearchManager == null) {
          return;
        }

        _this2.state.SearchManager.geocode({
          bounds: _this2.state.Map.getBounds(),
          where: _this2.state.Keyword,
          callback: function callback(answer, _userData) {
            _this2.state.Map.setView({
              bounds: answer.results[0].bestView
            });

            _this2.setPin(_this2.state.Map, answer.results[0].location.latitude, answer.results[0].location.longitude, _this2.state.LevelValue);

            _this2.setState({
              KeywordDangerText: null,
              LatitudeValue: Number(answer.results[0].location.latitude.toFixed(6)),
              LongitudeValue: Number(answer.results[0].location.longitude.toFixed(6))
            });
          },
          errorCallback: function errorCallback() {
            _this2.setState({
              KeywordDangerText: intl.format(Errors.DataNotFound, {
                title: _this2.state.Keyword
              })
            });
          }
        });
      });
    }
    /**
     * 「登録」ボタン押下時の処理を行います。
     */

  }, {
    key: "onEntry",
    value: function onEntry() {
      var _this3 = this;

      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        if (this.props.materialFileList.filter(function (m) {
          return m.toLowerCase() == Utility.NullStringToBlank(_this3.state.MaterialFileName).toLowerCase();
        }).length > 0) {
          var message = intl.format(Errors.ConfirmTerrainExists);
          message = Utility.NullStringToBlank(this.state.MaterialFileName).concat(message.split('\\n').join('\n'));
          var response = confirm(message);

          if (!response) {
            return;
          }
        }

        this.props.onEntry(this.props.sessionId, Utility.NullStringToBlank(this.state.MaterialFileName), this.state.LatitudeValue, this.state.LongitudeValue, this.state.LevelValue);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * MaterialFileName を変更します。
     *
     * @param e イベント
     */

  }, {
    key: "onChangeMaterialFileName",
    value: function onChangeMaterialFileName(e) {
      this.setState({
        MaterialFileName: e.target.value
      });
    }
    /**
     * キーワード を変更します。
     *
     * @param e イベント
     */

  }, {
    key: "onChangeKeyword",
    value: function onChangeKeyword(e) {
      this.setState({
        Keyword: e.target.value,
        KeywordDangerText: null
      });
    }
    /**
     * Longitude を変更します。
     *
     * @param e イベント
     */

  }, {
    key: "onChangeLongitude",
    value: function onChangeLongitude(e) {
      var longitudeValue = parseFloat(e.target.value);
      this.setState({
        LongitudeValue: longitudeValue
      });
      this.setPin(this.state.Map, this.state.LatitudeValue, longitudeValue, this.state.LevelValue);
    }
    /**
     * Latitude を変更します。
     *
     * @param e イベント
     */

  }, {
    key: "onChangeLatitude",
    value: function onChangeLatitude(e) {
      var latitudeValue = parseFloat(e.target.value);
      this.setState({
        LatitudeValue: latitudeValue
      });
      this.setPin(this.state.Map, latitudeValue, this.state.LongitudeValue, this.state.LevelValue);
    }
    /**
     * Latitude を変更します。
     *
     * @param e イベント
     */

  }, {
    key: "onInputLevel",
    value: function onInputLevel(e) {
      var level = parseFloat(e.target.value);
      this.setState({
        LevelValue: level
      });
      this.setPin(this.state.Map, this.state.LatitudeValue, this.state.LongitudeValue, level);
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      var modal = $('#TerrainModelingModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this4.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
      var map = new Microsoft.Maps.Map('#MapArea', {
        center: new Microsoft.Maps.Location(this.props.defaultCenterLatitude, this.props.defaultCenterLongitude),
        mapTypeId: Microsoft.Maps.MapTypeId.aerial,
        showLocateMeButton: false,
        showMapTypeSelector: false,
        showZoomButtons: false,
        showScalebar: false,
        enableInertia: false,
        enableClickableLogo: false,
        liteMode: true,
        zoom: this.props.mapZoom == null ? 4 : this.props.mapZoom
      });
      Microsoft.Maps.loadModule('Microsoft.Maps.Search', function () {
        _this4.setState({
          SearchManager: new Microsoft.Maps.Search.SearchManager(map)
        });
      });
      Microsoft.Maps.Events.addHandler(map, 'click', this.mapClicked.bind(this));
      this.setState({
        Map: map
      });
      this.setPin(map, this.props.defaultSelectLatitude, this.props.defaultSelectLongitude, this.props.defaultSelectLevel);
    }
    /**
     * Bing Map クリック時イベント処理
     *
     * @param e
     */

  }, {
    key: "mapClicked",
    value: function mapClicked(e) {
      this.setPin(e.target, e.location.latitude, e.location.longitude, this.state.LevelValue);
      this.setState({
        LatitudeValue: Number(e.location.latitude.toFixed(6)),
        LongitudeValue: Number(e.location.longitude.toFixed(6))
      });
    }
  }, {
    key: "setPin",
    value: function setPin(map, latitude, longitude, level) {
      var location = new Microsoft.Maps.Location(latitude, longitude);
      var rectDistance = Math.pow(2, 25 - level) / 1000;
      map.entities.clear();
      map.entities.push(new Microsoft.Maps.Pushpin(location, {
        icon: '/assets/img/pin_icon.svg',
        draggable: false,
        enableClickedStyle: false,
        enableHoverStyle: false,
        visible: true
      }));
      Microsoft.Maps.loadModule('Microsoft.Maps.SpatialMath', function () {
        var locations = Microsoft.Maps.SpatialMath.getRegularPolygon(location, rectDistance * Math.SQRT2, 4, Microsoft.Maps.SpatialMath.DistanceUnits.Kilometers);
        var polygon = new Microsoft.Maps.Polygon(locations, {
          fillColor: 'rgba(0,0,0,0)',
          strokeColor: '#00B06B',
          strokeThickness: 2
        });
        Microsoft.Maps.SpatialMath.Geometry.rotate(polygon, 45);
        map.entities.push(polygon);
      });
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "TerrainModelingModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "36",
        height: "38",
        src: "/assets/img/terrain_icon_gr.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(Terrain.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-1 col-10 form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "Longitude"
      }, intl.format(Label.Name)), /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "MaterialName",
        id: "MaterialName",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 50,
        value: Utility.NullStringToBlank(this.state.MaterialFileName),
        onChange: this.onChangeMaterialFileName.bind(this),
        tabIndex: 101,
        placeholder: intl.format(Placeholder.Letters, {
          value: "50"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "MaterialName",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "offset-1 col-10 form-group row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-6 leftarea"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-4 col-form-label",
        htmlFor: "Longitude"
      }, intl.format(Label.Longitude)), /*#__PURE__*/React.createElement("div", {
        className: "col-7"
      }, /*#__PURE__*/React.createElement("input", {
        type: "number",
        className: "form-control",
        name: "Longitude",
        id: "Longitude",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        max: "180",
        min: "-180",
        value: this.state.LongitudeValue,
        onChange: this.onChangeLongitude.bind(this),
        maxLength: 11,
        tabIndex: 102,
        placeholder: intl.format(Placeholder.Digits, {
          value: "11"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "Longitude",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-4 col-form-label",
        htmlFor: "Latitude"
      }, intl.format(Label.Latitude)), /*#__PURE__*/React.createElement("div", {
        className: "col-7"
      }, /*#__PURE__*/React.createElement("input", {
        type: "number",
        className: "form-control",
        name: "Latitude",
        id: "Latitude",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        max: "90",
        min: "-90",
        value: this.state.LatitudeValue,
        onChange: this.onChangeLatitude.bind(this),
        maxLength: 10,
        tabIndex: 103,
        placeholder: intl.format(Placeholder.Digits, {
          value: "10"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "Latitude",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-4 col-form-label",
        htmlFor: "Level"
      }, intl.format(Label.Level)), /*#__PURE__*/React.createElement("div", {
        className: "col-5 slidecontainer"
      }, /*#__PURE__*/React.createElement("input", {
        type: "range",
        min: "10",
        max: "20",
        step: "1",
        id: "LevelValue",
        onInput: this.onInputLevel.bind(this),
        value: this.state.LevelValue,
        tabIndex: 104
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        className: "form-control text-right",
        type: "number",
        min: "10",
        max: "20",
        step: "1",
        name: "Level",
        id: "Level",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        onInput: this.onInputLevel.bind(this),
        maxLength: 2,
        value: this.state.LevelValue,
        tabIndex: 105,
        placeholder: "level"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-6"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "Keyword",
        id: "Keyword",
        maxLength: 50,
        value: this.state.Keyword,
        onChange: this.onChangeKeyword.bind(this),
        tabIndex: 105,
        placeholder: intl.format(Placeholder.SearchWord)
      }), this.state.KeywordDangerText != null && /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        style: {
          fontSize: "16px"
        }
      }, this.state.KeywordDangerText)), /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary search",
        onClick: this.onSearch.bind(this),
        tabIndex: -1
      }, intl.format(Action.Search)))), /*#__PURE__*/React.createElement("div", {
        id: "MapArea",
        className: "maparea",
        style: {
          backgroundColor: "#1f1f1f"
        }
      })))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onEntry.bind(this),
        tabIndex: -1
      }, intl.format(Action.Entry))))));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };